module.exports = __webpack_public_path__ + "img/control2.b22cf222.svg";